/* tslint:disable */
/* eslint-disable */
/**
 * Datenbankgestalter.de API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { Message } from './Message';
import {
    MessageFromJSON,
    MessageFromJSONTyped,
    MessageToJSON,
} from './Message';
import type { Role } from './Role';
import {
    RoleFromJSON,
    RoleFromJSONTyped,
    RoleToJSON,
} from './Role';

/**
 * 
 * @export
 * @interface BulkMessageRequest
 */
export interface BulkMessageRequest {
    /**
     * 
     * @type {boolean}
     * @memberof BulkMessageRequest
     */
    allCustomers?: boolean;
    /**
     * 
     * @type {Array<string>}
     * @memberof BulkMessageRequest
     */
    customers?: Array<string>;
    /**
     * 
     * @type {Array<string>}
     * @memberof BulkMessageRequest
     */
    organisations?: Array<string>;
    /**
     * 
     * @type {Array<Role>}
     * @memberof BulkMessageRequest
     */
    roles?: Array<Role>;
    /**
     * 
     * @type {Message}
     * @memberof BulkMessageRequest
     */
    message?: Message;
}

/**
 * Check if a given object implements the BulkMessageRequest interface.
 */
export function instanceOfBulkMessageRequest(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function BulkMessageRequestFromJSON(json: any): BulkMessageRequest {
    return BulkMessageRequestFromJSONTyped(json, false);
}

export function BulkMessageRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): BulkMessageRequest {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'allCustomers': !exists(json, 'allCustomers') ? undefined : json['allCustomers'],
        'customers': !exists(json, 'customers') ? undefined : json['customers'],
        'organisations': !exists(json, 'organisations') ? undefined : json['organisations'],
        'roles': !exists(json, 'roles') ? undefined : ((json['roles'] as Array<any>).map(RoleFromJSON)),
        'message': !exists(json, 'message') ? undefined : MessageFromJSON(json['message']),
    };
}

export function BulkMessageRequestToJSON(value?: BulkMessageRequest | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'allCustomers': value.allCustomers,
        'customers': value.customers,
        'organisations': value.organisations,
        'roles': value.roles === undefined ? undefined : ((value.roles as Array<any>).map(RoleToJSON)),
        'message': MessageToJSON(value.message),
    };
}

